import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FilteredImagesCounter } from '../../components/filters/FilteredImagesCounter';
import { IProjectDetailsImagesStore } from '../../projectDetailsImages.store';

export const FilteredImagesCounterContainer = observer((): ReactElement => {
  const imagesStore = useInjection(IProjectDetailsImagesStore.$);
  return (
    <FilteredImagesCounter
      totalFilteredCount={imagesStore.imagesPaging.totalCount}
      totalImagesCount={imagesStore.imagesPaging.totalImagesCount}
    />
  );
});
